import { FieldValues, FormState, useFormContext, UseFormReturn } from 'react-hook-form';

export interface useFormContextHelperProps<TFieldValues>
  extends Omit<UseFormReturn<TFieldValues>, 'formState'> {
  formState: Partial<FormState<TFieldValues>>;
}

export function useFormContextHelper<TFieldValues extends FieldValues>(
  params?: Partial<useFormContextHelperProps<TFieldValues>>,
) {
  const contextFields = useFormContext<TFieldValues>();
  if (contextFields) {
    return contextFields;
  }
  if (params) {
    return params;
  }
  throw new Error(
    'useFormContextHelper should be either in a FormContext, or have the necessary useForm values passed as an argument.',
  );
}
